import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { addFormSet, AddFormSetAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useAddFormSet(): LocalOperation<
	(payload: ActionPayload<AddFormSetAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<AddFormSetAction>) {
		dispatch(addFormSet(payload));
	}

	return handler;
}
